<div class="static-content-wrapper text-start">
    <div class="main-workarea">
           <div class="container">
            <div class="mt-3 mb-5">
                <h1 class="heading">THE PDF Leader Privacy Policy</h1>
                <p>At The PDF Leader, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your information.</p>
            </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="static-content text-start">
                    <div class="heading-small">Information Collection</div>

                    <p>We may collect personal information from you when you use our services. This includes:</p>
                    <ul>
                        <li><p><strong>Name:</strong> We collect your name to personalize your experience and provide customer support.</p></li>
                        <li><p><strong>Email Address:</strong> Your email is used to communicate with you regarding your account, service updates, and promotional offers.</p></li>
                        <li><p><strong>Other Information:</strong> Any additional information you provide voluntarily during registration or usage of our services.</p></li>
                    </ul>
                
                    
                </div>

                <div class="static-content text-start">
                    <div class="heading-small">Use of Information</div>
                    <p>Your information may be used for the following purposes:</p>
                    <ul>
                        <li><p><strong>Service Provision:</strong> To provide, maintain, and improve our services.</p></li>
                        <li><p><strong>Communication:</strong> To communicate with you about your account and respond to your inquiries.</p></li>
                        <li><p><strong>Enhancement:</strong> To analyze user behavior to enhance the functionality and usability of our website.</p></li>
                    </ul>
                      
                </div>

                 <div class="static-content text-start">
                    <div class="heading-small">Data Retention</div>
                    <p>We will retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy. This may include:</p>
                    <ul>
                        <li><p>Legal obligations, such as compliance with applicable laws.</p></li>
                        <li><p>Business needs, including maintaining our services and customer support.</p></li>
                    </ul>
                      

                </div>

                <div class="static-content text-start">
                    <div class="heading-small">Security Measures</div>
                    <p>We take the security of your personal information seriously. Our measures include:</p>
                    <ul>
                        <li><p><strong>Encryption:</strong> Sensitive information is transmitted using encryption to protect your data.</p></li>
                        <li><p><strong>Access Controls:</strong> Access to personal information is restricted to authorized personnel only.</p></li>
                        <li><p><strong>Regular Audits:</strong> We conduct regular audits to ensure the effectiveness of our security measures.</p></li>
                    </ul>
                      

                </div>
                <div class="static-content text-start">
                    <div class="heading-small">Sharing of Information</div>

                    <p>We do not sell or rent your personal information to third parties. We may share your information with:</p>
                    <ul>
                        <li><p><strong>Service Providers:</strong> Third-party vendors who assist us in operating our website and delivering services.</p></li>
                        <li><p><strong>Compliance with Law:</strong> When required by law or to protect our rights.</p></li>
                    </ul>
                      
                </div>

                <div class="static-content text-start">
                    <div class="heading-small">User Rights</div>
                    <p>You have rights regarding your personal information, which include:</p>
            <ul>
                <li><p><strong>Access:</strong> You can request a copy of your personal data that we hold.</p></li>
                <li><p><strong>Correction:</strong> You can request that we correct any inaccuracies in your personal data.</p></li>
                <li><p><strong>Deletion:</strong> You have the right to request the deletion of your personal data under certain conditions.</p></li>
            </ul>
                      
                </div>
                <div class="static-content text-start">
                    <div class="heading-small">Cookies</div>
                    <p>Our website may use cookies to enhance user experience. Cookies are small text files stored on your device to improve your interaction with our services. You can:</p>
                    <ul>
                        <li><p><strong>Manage Cookies:</strong> Choose to accept or decline cookies through your browser settings.</p></li>
                        <li><p><strong>Understand Usage:</strong> Learn more about how we use cookies and similar technologies.</p></li>
                    </ul>
                </div>

                <div class="static-content text-start">
                    <div class="heading-small">Changes to this Privacy Policy</div>
                    <p>We may update our Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date, and we encourage you to review this page periodically.</p>
                      
                </div>

                <div class="static-content text-start">
                    <div class="heading-small">Contact Us</div>
                    <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@thepdfleader.com">support&#64;thepdfleader.com</a>. We value your feedback and will respond promptly to your inquiries.</p>
                      
                </div> 
            </div>
        </div>
    </div>
    </div>
</div>